<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <v-overlay :value="!dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <strong color="#871B12" class="pa-5">รายงานการลาออก</strong>

        <v-row class="pa-2">
          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
               <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                prepend-inner-icon="mdi-map-marker-radius"
                class="ma-2"
            ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-map-marker"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                filled
                hide-details
                prepend-inner-icon="mdi-briefcase"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>

          <v-col cols="6">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                clearable
                clear-icon="mdi-close-circle"
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <v-btn
                class="ml-5 mt-2"
                color="#173053"
                dark
                @click="getData()"
              >
                <v-icon left size="20"
                  >mdi-calendar-search</v-icon
                >
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>
       <v-row class="pa-5">
          <v-col cols="6">
            <v-card rounded="xl">
              <v-card-title class="text-h6">
                <v-icon left> mdi-chart-bar </v-icon>
                จำนวนการลาออกของพนักงาน
              </v-card-title>
              <canvas class="pa-5" id="myChartSearch"></canvas>
            </v-card>
          </v-col>
        </v-row>
       <v-row class="pa-5">
          <v-col cols="12">
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columns"
                :items="dataItemResign"
                :search="searchAll2"
                :items-per-page="10"
              >
                <!-- <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                  icon
                    color="#130A29"
                    fab
                    small
                    @click.stop=";(dialog = true), getByEmp(item)"
                  >
                    <v-icon dark> mdi-map-marker-radius </v-icon>
                  </v-btn>
                </template> -->
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import dayName from '../../assets/master/Date/day.json'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    apexchart: VueApexCharts,
    moment,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงานการลาออก',
          disabled: false,
          href: '/Dashbord/DashbordResign'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        // { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'วันเข้าทำงาน', value: 'startDate' },
        { text: 'วันที่ลาออก', value: 'endDate' },
        { text: 'อายุงาน', value: 'workDate' }
      ],
      dataItemResign: [],
      export_data: [],
      export_data_by_month: [],
      dataByEmp: [],
      dataByEmpView: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      disableExport: false,
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      branch1: 0, // สำนักงานใหญ่
      branch2: 0, // สาขาปากเกร็ด - เมืองทอง
      branch3: 0, // สาขาแจ้งวัฒนะ
      branch4: 0, // สาขาหนองแขม
      branch5: 0, // สาขาบางกอกน้อย
      branch6: 0 // House Development
    }
  },
  async mounted () {
    await this.getGetToken()
    this.dataReady = false

    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    await this.getData()
    await this.getDataResignCount()
  },
  methods: {
    async getData () {
      await this.searchCharJSCheckINOUT()
      await this.getDataResign()
    },
    async getDataResignCount () {
      this.dataReady = false
      this.dataItemResign = []
      this.branch1 = 0
      this.branch2 = 0
      this.branch3 = 0
      this.branch4 = 0
      this.branch5 = 0
      this.branch6 = 0

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_resign/get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemResign = response.data
          this.dataItemResign.forEach(branchItem => {
            if (branchItem.masBranchName === 'สำนักงานใหญ่') {
              this.branch1 += 1
            }
            if (branchItem.masBranchName === 'สาขาปากเกร็ด - เมืองทอง') {
              this.branch2 += 1
            }
            if (branchItem.masBranchName === 'สาขาแจ้งวัฒนะ') {
              this.branch3 += 1
            }
            if (branchItem.masBranchName === 'สาขาหนองแขม') {
              this.branch4 += 1
            }
            if (branchItem.masBranchName === 'สาขาบางกอกน้อย') {
              this.branch5 += 1
            }
            if (branchItem.masBranchName === 'House Development') {
              this.branch6 += 1
            }
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      this.branch1 = this.branch1 < 0 ? 0 : this.branch1
      this.branch2 = this.branch2 < 0 ? 0 : this.branch2
      this.branch3 = this.branch3 < 0 ? 0 : this.branch3
      this.branch4 = this.branch4 < 0 ? 0 : this.branch4
      this.branch5 = this.branch5 < 0 ? 0 : this.branch5
      this.branch6 = this.branch6 < 0 ? 0 : this.branch6
      await this.searchCharJSCheckINOUT()
    },
    async getDataResign () {
      this.dataReady = false
      this.dataItemResign = []

      // this.leaveType = (this.leaveType) ? this.leaveType : null
      // this.month = (this.month) ? this.month : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      // var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      // var monthSearch = (this.month !== null) ? '&leaveStartMonth=' + this.getMonthThToINT(this.month) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/employee_resign/get' +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemResign = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_company/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_branch/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/master_department/getItem',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async searchCharJSCheckINOUT () {
      console.log('สำนักงานใหญ่', this.branch1)
      console.log('สาขาปากเกร็ด - เมืองทอง', this.branch2)
      console.log('สาขาแจ้งวัฒนะ', this.branch3)
      console.log('สาขาหนองแขม', this.branch4)
      console.log('สาขาบางกอกน้อย', this.branch5)
      console.log('House Development', this.branch6)
      var ctx = document.getElementById('myChartSearch')
      var myChartSearch = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'bar',
        data: {
          labels: ['สำนักงานใหญ่', 'สาขาปากเกร็ด - เมืองทอง', 'สาขาแจ้งวัฒนะ', 'สาขาหนองแขม', 'สาขาบางกอกน้อย', 'House Development'],
          datasets: [
            // {
            //   label: 'Number of Moons',
            //   data: [0, 0, 1, 2, 79, 82, 27, 14],
            //   backgroundColor: 'rgba(54,73,93,.5)',
            //   borderColor: '#36495d',
            //   borderWidth: 3
            // },
            {
              label: 'จำนวนพนักงานที่ลาออก แต่ละสาขา',
              data: [this.branch1, this.branch2, this.branch3, this.branch4, this.branch5, this.branch6],
              backgroundColor: 'rgba(71, 183,132,.5)',
              borderColor: '#47b784',
              borderWidth: 3
            }
          ]
        },
        options: {
          responsive: true,
          lineTension: 1,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 25
                }
              }
            ]
          }
        }
      })
      console.log(myChartSearch)
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #262A34;
}
.Color-Font {
  color: #808588;
}
.Color-Font-Action {
  color: #b61c1c;
}
.Color-Font-Preview {
  color: #262a34;
}
.Color-Button {
  color: #b61c1c;
}
.Divider {
  border: 2px solid #808588;
  background: #808588;
  border-radius: 5px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashbord/DashbordResign.vue